export default [
  {
    path: 'region',
    name: 'region',
    component: () => import('@/views/pages/region/Region.vue'),
    meta: {
      pageTitle: 'Region',
      breadcrumb: [
        {
          text: 'Region',
          active: true,
        },
      ],
      resource: 'All',
    },
  },
]
